import { create } from 'zustand';
export const useScheduleOutput = create(() => ({
    broadcasts: [],
}));
const reactiveOutput = {
    useScheduledBroadcasts: () => {
        return useScheduleOutput((s) => s.broadcasts);
    },
};
// This class should be used by the ScheduleService only
export class ScheduleServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    // Single entry-point setter used by the ScheduleService
    setBroadcasts(broadcasts) {
        useScheduleOutput.setState({
            broadcasts,
        });
    }
}
